import React, { Component } from "react";

class ChildName extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (<p className="detail__child-name beta">{this.props.childName}</p>);
  }
}

export default ChildName;
